import { render, staticRenderFns } from "./ModifyTeamMeasure.vue?vue&type=template&id=54deeb50"
import script from "./ModifyTeamMeasure.vue?vue&type=script&lang=js"
export * from "./ModifyTeamMeasure.vue?vue&type=script&lang=js"
import style0 from "./ModifyTeamMeasure.vue?vue&type=style&index=0&id=54deeb50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports